import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import { Box, Skeleton } from "@mui/material"; // ✅ use Skeleton
import "@/components/callendar/fullcalender/css/callendar.css";

export default function Calendar({
  events,
  eventclick,
  onMonthChange,
  dialogOpen,
  loading,
}) {
  const [skeletonEvents, setSkeletonEvents] = useState([]);

  const handleDatesSet = (arg) => {
    const date = new Date(arg.view.currentStart);
    const month = date.getMonth();
    const year = date.getFullYear();

    const skeleton = Array.from({ length: 30 }, (_, i) => ({
      id: `skeleton-${i + 1}`,
      title: "skeleton",
      start: new Date(year, month, i + 1).toISOString().split("T")[0],
    }));

    setSkeletonEvents(skeleton);

    const currentMonth = `${year}-${(month + 1).toString().padStart(2, "0")}`;
    onMonthChange?.(currentMonth);
  };

  const coloredEvents = events.map((event) => ({
    ...event,
    eventColor: event.labelColor || "#34754F",
    eventTextColor: "white",
  }));

  useEffect(() => {
    if (dialogOpen) {
      const popover = document.querySelector(".fc-popover");
      if (popover) {
        const closeButton = popover.querySelector(".fc-popover-close");
        if (closeButton) {
          closeButton.click();
        } else {
          document.body.click();
        }
      }
    }
  }, [dialogOpen]);

  return (
    <FullCalendar
      viewClassNames="event-calendar-view"
      allDayClassNames="events-all-day"
      dayHeaderClassNames="evetnts-day-header"
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
      initialView="dayGridMonth"
      fixedWeekCount={false}
      headerToolbar={{
        left: "prev,next",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
      }}
      views={{
        listWeek: {
          listDayFormat: { weekday: "long" },
          listDaySideFormat: {
            month: "short",
            day: "numeric",
            year: "numeric",
          },
        },
      }}
      // 🔹 Use skeletonEvents while loading, else real events
      events={loading ? skeletonEvents : coloredEvents}
      dayMaxEvents={3}
      eventContent={(arg) =>
        loading ? (
          <Box sx={{ width: "100%" }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{ borderRadius: "10px" }}
            />
          </Box>
        ) : (
          <span>{arg.event.title}</span>
        )
      }
      eventDidMount={(info) => {
        if (loading) {
          // remove FullCalendar default blue bg
          info.el.style.backgroundColor = "transparent";
          info.el.style.border = "none";
          info.el.style.boxShadow = "none";
        } else {
          const labelColor = info.event.extendedProps.labelColor;
          if (labelColor) {
            info.el.style.backgroundColor = labelColor;
            info.el.style.color = "white";
          }
        }
      }}
      eventClick={!loading ? eventclick : undefined}
      datesSet={handleDatesSet} // 🔹 Triggers skeleton update when month changes
      moreLinkClick={(arg) => {
        if (dialogOpen) {
          return false;
        }
        return "popover";
      }}
    />
  );
}
